module.exports = __webpack_public_path__ + "static/media/investigation committee.2f0d2b12.svg";